export class DropDownItem {
    constructor(idDropDownItem?:string,itemText?:string,codDropDownSource?:string,idDropDownFather?:string,identifyCode?:string, deletionDate?:Date){
        (idDropDownItem) ? this.idDropDownItem = idDropDownItem : this.idDropDownItem = null;
        (codDropDownSource) ? this.codDropDownSource = codDropDownSource : this.codDropDownSource = null;
        (itemText) ? this.itemText = itemText : this.itemText = null;
        (idDropDownFather) ? this.idDropDownFather = idDropDownFather : this.idDropDownFather = null;
        (identifyCode) ? this.identifyCode = identifyCode : this.identifyCode = null;
        (this.deletionDate) ? this.deletionDate = deletionDate : this.deletionDate = null;
    }
    public idDropDownItem:string;
    public itemText:string;
    public codDropDownSource:string;
    public idDropDownFather:string;
    public identifyCode:string;
    public deletionDate:Date;
}

export interface SelectDropDownItem {
    value: string;
    text: string;
    identifyCode: string;
    deletionDate: Date;
}